import Shape from './Shape';

export default Shape;
